import t from "./ghl-ui.es1378.js";
import a from "./ghl-ui.es371.js";
import u from "./ghl-ui.es372.js";
import o from "./ghl-ui.es1237.js";
import e from "./ghl-ui.es692.js";
import g from "./ghl-ui.es750.js";
function P(r, m, s) {
  m = t(m, r);
  for (var n = -1, i = m.length, f = !1; ++n < i; ) {
    var l = g(m[n]);
    if (!(f = r != null && s(r, l)))
      break;
    r = r[l];
  }
  return f || ++n != i ? f : (i = r == null ? 0 : r.length, !!i && e(i) && o(l, i) && (u(r) || a(r)));
}
export {
  P as default
};
